import React from 'react';
import s from './BaseComp.scss';
import { FeedInstance } from '../../models/feed';
import { linkHelper } from '../../utils/linkHelper';
import { LinkWrapper } from './LinkWrapper';

interface ItemProps {
    article: FeedInstance,
    bold?: boolean,
}

/**
 * @component
 * Text Item in card
 * @param props {ItemProps} - props
 */
export const TextFeedItem = (props: ItemProps) => {
    return (
        <div>
            <LinkWrapper className={s.textComp} href={linkHelper(props.article.url)}>
                <p className={s.label} style={{ fontWeight: props.bold ? 700 : 'inherit' }}>{props.article.title.replace('✎', '')}</p>
            </LinkWrapper>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/BaseComp/TextFeedItem.tsx